import { indexItems } from '@/mocks/cinema';

export default function SectionIndex() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            专题合集
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            按你的口味找到心仪好剧，热门专题每日更新
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href={item.href}
              className={`group flex flex-col items-center p-4 md:p-5 rounded-xl transition-all duration-200 cursor-pointer ${
                item.accent
                  ? 'bg-accent-500/10 hover:bg-accent-500/20 border border-accent-500/20'
                  : 'bg-background-50 hover:bg-background-200 border border-background-200/30'
              }`}
            >
              <div
                className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full mb-3 transition-transform duration-200 group-hover:scale-110 ${
                  item.accent
                    ? 'bg-accent-500/20 text-accent-400'
                    : 'bg-background-200 text-foreground-400 group-hover:text-primary-400'
                }`}
              >
                <i className={`${item.icon} text-xl`} />
              </div>
              <span
                className={`text-sm font-medium whitespace-nowrap mb-1 ${
                  item.accent ? 'text-accent-400' : 'text-foreground-300'
                }`}
              >
                {item.title}
              </span>
              <span className="text-xs text-foreground-600 text-center leading-relaxed hidden lg:block">
                {item.description}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}